import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { OperatorLocksActions } from './operator-locks.actions';
import { OperatorLocksSelectors } from './operator-locks.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {Item} from '@emm/core/models/item.model';
import {getActionQueries} from '@emm/core/util/ngrx.util';


export interface EmergencyItemsQueries extends AsyncActionQueries {} // todo

@Injectable({ providedIn: 'root' })
export class OperatorLocksStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>, private actions$: Actions) {
        super(store, OperatorLocksSelectors);
    }

    dispatch = {
        loadItemsByEmergency: (tag: string) =>
            this.store.dispatch(OperatorLocksActions.loadItemsByLock({ tag })),
        loadAllChildItems: (id: string) =>
            this.store.dispatch(OperatorLocksActions.loadAllChildItems({ id })),
        openAddEmergencyItemDialog: () =>
            this.store.dispatch(OperatorLocksActions.openAddDialog()),
        addChildEmergencyItem: (emergencyTag: string, file: FormData) =>
            this.store.dispatch(OperatorLocksActions.addChildItem({ emergencyTag, file })),
        removeChildEmergencyItem: (emergencyTag: string, itemTag: string) =>
            this.store.dispatch(OperatorLocksActions.removeChildItem({ emergencyTag, itemTag })),
        updateStatusMessage: (emergencyTag: string, statusMessage: string, active: boolean, subType: string) =>
            this.store.dispatch(OperatorLocksActions.updateStatusMessage({ emergencyTag, statusMessage, active,
                subType }))
    };

    queries: EmergencyItemsQueries = {
        ...this.asyncActionQueries,
        ...getActionQueries({
            actionCreators: OperatorLocksActions,
            actions$: this.actions$
        })
    };

}
